export default __webpack_public_path__ + "static/media/Microbiologie.2ff2ea23.jpg";